import React from 'react'

export const renderParagraphWithLinebreaks = ({
  intl,
  paragraphClassName = '',
  messageId,
}) => {
  const str = intl?.formatMessage({ id: messageId })
  if ((str ?? '').trim() === '' || str === messageId) {
    return null
  }
  return (
    <p className={paragraphClassName}>
      {str.split('\n').map((text, i) => (
        <React.Fragment key={i}>
          {text}
          <br />
        </React.Fragment>
      ))}
    </p>
  )
}
